import { Droplets, Settings, SearchCheck, Hammer, Wrench, ShieldCheck } from "lucide-react";

/**
 * Data layanan untuk Rumah & Hunian (B2C).
 */
export const residentialServices = [
  { id: "cuci-ac", icon: Droplets, title: "Cuci AC", description: "Pembersihan unit indoor & outdoor untuk menjaga performa." },
  { id: "service-ac", icon: Settings, title: "Service AC", description: "Perawatan unit AC rumah agar tetap dingin dan nyaman." },
  { id: "pemeriksaan", icon: SearchCheck, title: "Pemeriksaan", description: "Pengecekan kondisi unit untuk mendeteksi kebutuhan perawatan." },
  { id: "instalasi", icon: Hammer, title: "Instalasi", description: "Pemasangan unit AC baru untuk hunian." },
  { id: "troubleshooting", icon: Wrench, title: "Troubleshooting", description: "Penanganan masalah pada unit AC rumah Anda." },
  { id: "home-care", icon: ShieldCheck, title: "Home Care", description: "Perawatan berkala agar AC rumah lebih awet dan terjaga." },
];

export default residentialServices;
